// <script src="https://www.gstatic.com/firebasejs/5.0.3/firebase.js"></script>
// <script>
// document.addEventListener('DOMContentLoaded', function() {
//   // TODO: Implement getParameterByName()
//
//   // Get the action to complete.
//   var mode = getParameterByName('mode');
//   // Get the one-time code from the query parameter.
//   var actionCode = getParameterByName('oobCode');
//   // (Optional) Get the API key from the query parameter.
//   var apiKey = getParameterByName('apiKey');
//   // (Optional) Get the continue URL from the query parameter if available.
//   var continueUrl = getParameterByName('continueUrl');
//
//   // Configure the Firebase SDK.
//   // This is the minimum configuration required for the API to be used.
//   var config = {
//     'apiKey': apiKey  // This key could also be copied from the web
//                       // initialization snippet found in the Firebase console.
//   };
//   var app = firebase.initializeApp(config);
//   var auth = app.auth();
//
//   // Handle the user management action.
//   switch (mode) {
//     case 'resetPassword':
//       // Display reset password handler and UI.
//       handleResetPassword(auth, actionCode, continueUrl);
//       break;
//     case 'recoverEmail':
//       // Display email recovery handler and UI.
//       handleRecoverEmail(auth, actionCode);
//       break;
//     case 'verifyEmail':
//       // Display email verification handler and UI.
//       handleVerifyEmail(auth, actionCode, continueUrl);
//       break;
//     default:
//       // Error: invalid mode.
//   }
// }, false);
// </script>

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { Layout, Form, Icon, Input, Button } from 'antd';
const {Content} = Layout;

export default class Verifier extends Component {
  constructor(props) {
    super(props);
    this.state = { };
  }


  render() {
    return(
      <h1>HELLLO</h1>
    );
  }
}
// export default withRouter(Verifier);
// export {
//   Verifier
// };



// WEBPACK FOOTER //
// ./src/Verifier.js